/**
 * Date helpers that respect the user's local timezone.
 *
 * JS's `new Date().toISOString()` returns UTC, which is a day ahead/behind
 * local time for most users during most of the day. Meeting/notes dates are
 * calendar dates (not timestamps), so we want the user's LOCAL date regardless
 * of their offset from UTC.
 */

/**
 * Today's calendar date in the user's local timezone, formatted YYYY-MM-DD.
 * Safe for <input type="date"> values and server-side date columns.
 */
export function getLocalDateString(d: Date = new Date()): string {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
